import PropTypes from 'prop-types'
import React from 'react'
import { ReactComponent as SvgIcon } from '@fortawesome/fontawesome-pro/svgs/light/globe.svg'
import BaseIcon from '../../BaseIcon'

const Globe = ({ className }) => {
	return <BaseIcon component={SvgIcon} className={className} viewBox="0 0 496 512" />
}
Globe.propTypes = {
	className: PropTypes.string,
}

export default Globe
